export const TASK_PRIORITY = {
  HIGHEST: 1,
  HIGH: 10,
  MID: 100,
  LOW: 1000,
} as const;
